import React, { useState } from 'react';
import { Card, Stack, Tab, Tabs } from '@mui/material';
import ListInputs from '@screens/Catalog/Inputs/ListInputs';
import ListInputCategories from '@screens/Catalog/Inputs/ListInputCategories';
import ListRecipes from '@screens/Catalog/Recipes/ListRecipes';
import ListModifierGroups from '@screens/Catalog/ModifierGroups/ListModifierGroups';
import ListDishes from '@screens/Catalog/Dishes/ListDishes';
import ListProductCategories from '@screens/Catalog/ProductCategories/ListProductCategories';

// Catálogo GLOBAL completo (decisión de Irving 2026-08-11: insumos con sus categorías se
// mudaron aquí desde CEDIS, y categorías de productos desde el engranaje de /menu — todo
// lo global vive junto; los inventarios siguen por CEDIS/sucursal). Orden de tabs =
// cadena de captura: Insumos → Recetas → Modificadores → Productos → sus categorías.
const CatalogScreen: React.FunctionComponent = () => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Stack height="100%" spacing={2} p={2}>
            <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)} variant="scrollable">
                <Tab label="Insumos" />
                <Tab label="Categorías de insumos" />
                <Tab label="Recetas" />
                <Tab label="Modificadores" />
                <Tab label="Productos" />
                <Tab label="Categorías de productos" />
            </Tabs>
            <Stack component={Card} flex={1}>
                {activeTab === 0 && <ListInputs />}
                {activeTab === 1 && <ListInputCategories />}
                {activeTab === 2 && <ListRecipes />}
                {activeTab === 3 && <ListModifierGroups />}
                {activeTab === 4 && <ListDishes />}
                {activeTab === 5 && <ListProductCategories />}
            </Stack>
        </Stack>
    );
};

export default CatalogScreen;
